// extracted by mini-css-extract-plugin
export var galleryMasonryImageWrapper = "r_jQ d_jQ d_cv";
export var galleryMasonryImage = "r_jP d_jP d_w d_bR d_dB";
export var alignLeft = "r_qh d_fp d_bG d_dv";
export var alignCenter = "r_bP d_fq d_bD d_dw";
export var alignRight = "r_qj d_fr d_bH d_dx";
export var galleryContainer = "r_ry d_dW";
export var galleryContainerFull = "r_rz d_dT";
export var galleryRowWrapper = "r_rB d_cc";
export var galleryGuttersImage = "r_jS d_jS d_K d_cv";
export var galleryNoGuttersImage = "r_jR d_jR d_K d_cD";
export var galleryTextGutters = "r_jM d_jM d_cw";
export var galleryTextNoGutters = "r_jN d_jN d_cw";
export var galleryTextMasonry = "r_rC d_jM d_cw";
export var galleryImageWrapper = "r_rD d_fg d_Z";
export var descText = "r_rF d_jT d_0 d_9 d_7 d_8 d_n";
export var guttersDesc = "r_rG";